module.exports = __webpack_public_path__ + "static/media/blueBackdrop.421811be.png";